import { AutoComplete } from 'antd';
import classNames from 'classnames';
import ErrorMessage from '../errorMessage';
import InputTitle from '../inputTitle';
import type { IProps } from './types';
import { useAutoComplete } from './useAutoComplete';
import './style.scss';

/**
 * Address autocomplete input with a title, clear support and an error message. Delegates suggestion lookup and value handling to useAutoComplete with the country, isSearchCity, value and change or clear callbacks, disables client-side filtering so the option list comes from the hook, and marks the field with error status when isError is set.
 *
 * @param props - Field configuration, country, value and the change callbacks.
 * @returns The autocomplete field markup.
 */
export const AutoCompleteInput = (props: IProps) => {
  const { size = 'middle' } = props;
  const { state, antSize, onChange, handleSearch } = useAutoComplete({
    country: props.country,
    isSearchCity: props.isSearchCity,
    onChangeInput: props.onChangeInput,
    onChangeAddress: props.onChangeAddress,
    eventClear: props.eventClear,
    value: props.value,
    size: props.size,
    googleApiKey: props.googleApiKey,
  });

  return (
    <div className={classNames('custom-auto-complete-wrapper', props.className)}>
      <InputTitle title={props.title} isRequired={props.isRequired} />

      <AutoComplete
        className={classNames('custom-auto-complete', `custom-auto-complete--size-${size}`)}
        disabled={props.disabled}
        placeholder={props.placeholder}
        status={props.isError ? 'error' : undefined}
        options={state.addressArray}
        filterOption={() => true}
        value={state.address}
        // onInputChange={onInputChange}
        onChange={onChange}
        onSearch={handleSearch}
        allowClear={props.allowClear}
        size={antSize}
        id={props.id}
        aria-label={props['aria-label'] ?? props.title}
        onInputKeyDown={props.onInputKeyDown}
      />

      {props.errorMessage && (
        <ErrorMessage className="errorMessage" errorMessage={props.errorMessage} hasIcon />
      )}
    </div>
  );
};

export default AutoCompleteInput;
